export default function CustomMarker(latlng, map, args, info, callback) {
  this.latlng = latlng;
  this.args = args;
  this.info = info;
  this.callback = callback;
  this.setMap(map);
}

CustomMarker.prototype = new window.google.maps.OverlayView();

CustomMarker.prototype.draw = function() {
  var self = this;

  var div = this.div;

  if (!div) {
    div = this.div = document.createElement("div");

    div.className = "marker";
    div.textContent = this.info;
    const style = div.style;

    style.position = "absolute";
    style.color = "white";
    style.cursor = "pointer";
    style.width = "40px";
    style.height = "40px";
    style.background = "rgba(50, 112, 250, 0.6)";
    style.boxShadow = "0px 3px 10px 0px rgba(0,0,0,0.5)";
    style.borderRadius = "100%";
    style.textAlign = "center";
    style.border = "4px solid rgba(50, 112, 250, 1)";
    style.fontWight = "bold";
    style.fontSize = "16px";
    style.lineHeight = "33px";
    style.margin = "0px";

    div.onclick = () => this.callback();

    if (typeof self.args.marker_id !== "undefined") {
      div.dataset.marker_id = self.args.marker_id;
    }

    var panes = this.getPanes();
    panes.overlayImage.appendChild(div);
  }

  var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

  if (point) {
    div.style.left = point.x + "px";
    div.style.top = point.y + "px";
  }
};

CustomMarker.prototype.remove = function() {
  if (this.div) {
    this.div.parentNode.removeChild(this.div);
    this.div = null;
  }
};

CustomMarker.prototype.getPosition = function() {
  return this.latlng;
};



// WEBPACK FOOTER //
// ./src/helpers/CustomMarker.js